<template>
  <div>
    <bs-card class="card-info" :icon="icon" :label="labels.name">
      <template v-slot:header>
        <bs-button class="btn-sm btn-info" @click="create">{{ labels.create }}</bs-button>
      </template>
      <bs-table v-bind="{dataLength, loading}" :cols="2">
        <template v-slot:thead>
          <tr>
            <th scope="col">{{ $t('labels.name') }}</th>
            <th scope="col"></th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td>
            <span class="d-flex">
              <span :class="'sm-swatch bg-' + r.color"></span>
              <span class="pl-2">{{ r.label }}</span>
            </span>
          </td>
          <td class="t2">
            <bs-action :icon="['fal', 'pencil']" :tip="labels.edit" class="btn-info" @click="update(r)"></bs-action>
            <bs-action :icon="['fal', 'trash']" :tip="labels.delete" class="btn-danger" @click="destroy(r)"></bs-action>
          </td>
        </tr>
        <template v-slot:tfoot>
          <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
        </template>
      </bs-table>
    </bs-card>
    <bs-modal :name="'create-' + $options.name" :label="resource.id ? labels.edit : labels.create">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="slotProps">
          <input-field :name="'label'" :label="$t('labels.name')" v-model="resource.label" :error="slotProps.error"></input-field>
          <select-field :name="'color'" :label="$t('labels.color')" v-model="resource.color" :error="slotProps.error">
            <option value="blue">Blue</option>
            <option value="indigo">Indigo</option>
            <option value="purple">Purple</option>
            <option value="pink">Pink</option>
            <option value="red">Red</option>
            <option value="light-red">Light Red</option>
            <option value="orange">Orange</option>
            <option value="light-orange">Light Orange</option>
            <option value="yellow">Yellow</option>
            <option value="light-yellow">Light Yellow</option>
            <option value="green">Green</option>
            <option value="teal">Teal</option>
            <option value="cyan">Cyan</option>
          </select-field>
        </template>
      </bs-form>
    </bs-modal>
    <bs-modal :name="'destroy-' + $options.name" :label="labels.delete">
      <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
        {{ $t('messages.delete', { resource: camelToSpace(singular($options.name)) }) }}
      </bs-form>
    </bs-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { resourceControl } from '../../mixins/resourceControl'

export default {
  name: 'Tags',
  mixins: [resourceControl],
  data () {
    return {
      icon: ['fal', 'tags'],
      resource: {
        label: '',
        color: null
      }
    }
  },
  computed: {
    ...mapState({
      resources: state => state.tags,
      resourceState: state => state.tagsState,
      resourceStore: state => state.tagsStore
    })
  }
}
</script>
